import { getToken } from "../utils/utilFunctions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const headers = () => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${getToken()}`,
});

/**
 * Get all companies (admin usage)
 */
export async function fetchAllCompanies() {
    const res = await fetch(`${API_URL}/api/userCompanies/all`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Get the company of the currently logged in user
 */
export async function fetchMyCompany() {
    const res = await fetch(`${API_URL}/api/userCompanies/`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Get a specific company by ID
 * @param {number|string} id
 */
export async function fetchCompanyById(id) {
    const res = await fetch(`${API_URL}/api/userCompanies/${id}`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Create a new company
 * @param {object} companyData
 */
export async function createCompany(companyData) {
    const res = await fetch(`${API_URL}/api/userCompanies`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(companyData),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Update a company by ID
 * @param {number|string} id
 * @param {object} updatedData
 */
export async function updateCompany(id, updatedData) {
    const res = await fetch(`${API_URL}/api/userCompanies/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(updatedData),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

/**
 * Delete a company by ID
 * @param {number|string} id
 */
export async function deleteCompany(id) {
    const res = await fetch(`${API_URL}/api/userCompanies/${id}`, {
        method: "DELETE",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return true;
}
